export const SET_REQUESTS = 'SET_REQUESTS';
export const CLEAR_REQUESTS = 'CLEAR_REQUESTS';
export const SET_REQUESTS_LIST_OPTIONS = 'SET_REQUESTS_LIST_OPTIONS';
